module.exports = __webpack_public_path__ + "static/media/ucc.a466931b.png";